

export const getReturnReasonTypesDataPath = (orderId:string) => `/api/v1/sales-order/${orderId}/reasons`;
